
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8812"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8812"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
/**
 * Copyright © VNG Realisatie 2025
 * Licensed under the EUPL
 */ 
var $baPnr = parcelRequire("baPnr");
$ebd7e96bf912d9f9$var$enablePeerSelectInstances();
document.body.addEventListener('htmx:afterSettle', function() {
    $ebd7e96bf912d9f9$var$enablePeerSelectInstances();
});
function $ebd7e96bf912d9f9$var$enablePeerSelectInstances() {
    document.querySelectorAll('.peer-select').forEach((el)=>{
        let settings = {
            valueField: 'peer_id',
            labelField: 'peer_name',
            searchField: [
                'peer_name',
                'peer_id'
            ],
            sortField: [
                {
                    field: 'peer_name',
                    direction: 'asc'
                }
            ],
            preload: true,
            load: function(query, callback) {
                let self = this;
                if (self.loading > 1) {
                    callback();
                    return;
                }
                fetch('/peer-select').then((response)=>response.json()).then((json)=>{
                    callback(json);
                    self.settings.load = null;
                }).catch(()=>{
                    callback();
                });
            },
            render: {
                item: function(item, escape) {
                    const peerName = item.peer_name;
                    const peerID = item.peer_id;
                    if (peerName && peerName !== '') return '<div>' + escape(peerName) + '</div>';
                    return '<div>' + escape(peerID) + '</div>';
                },
                option: function(item, escape) {
                    const peerName = item.peer_name;
                    const peerID = item.peer_id;
                    if (peerName && peerName !== '') return '<div><span class="label">' + escape(peerName) + '</span>' + '<small class="caption">' + escape(peerID) + '</small>' + '</div>';
                    return '<div><span class="label">' + escape(peerID) + '</span>' + '</div>';
                }
            }
        };
        const select = new $baPnr(el, settings);
        select.on('load', function(loadedItems) {
            const self = this;
            if (!loadedItems || !self.items || !self.items[0]) return;
            const selectedItem = loadedItems.find(function(item) {
                return item.peer_id === self.items[0];
            });
            self.updateOption(selectedItem.peer_id, selectedItem);
        });
    });
}


//# sourceMappingURL=controller.898c8d8a.js.map
